import { useStaticQuery, graphql } from "gatsby"

import { useI18next } from "gatsby-plugin-react-i18next"

export default function useMenus() {
  const { t } = useI18next()

  const submenus = useStaticQuery(graphql`
    {
      affirmations {
        page_contents {
          header_title
          slug
        }
      }
      scholarshipTargeted {
        page_contents {
          header_title
          slug
        }
      }
      scholarshipGenerals {
        page_contents {
          slug
          header_title
        }
      }
      scholarshipCollaborations {
        page_contents {
          slug
          header_title
        }
      }
      researchRisproMandatories {
        page_contents {
          header_title
          slug
        }
      }
      researchRisproInvitations {
        page_contents {
          header_title
          slug
        }
      }
      researchRisproCompetitions {
        page_contents {
          slug
          header_title
        }
      }
      researchRisproCollaborations {
        page_contents {
          slug
          header_title
        }
      }
    }
  `)

  const menus = [
    {
      title: t("Tentang"),
      key: "tentang",
      link: "#",
      submenu: [
        {
          title: t("Selayang Pandang"),
          key: "selayang-pandang",
          link: "/tentang/selayang-pandang/",
        },
        {
          title: t("Visi & Misi"),
          key: "visi-misi",
          link: "/tentang/visi-misi/",
        },
        {
          title: t("Struktur Organisasi"),
          key: "struktur-organisasi",
          link: "/tentang/struktur-organisasi/",
        },
        {
          title: t("Manajemen"),
          key: "manajemen",
          link: "#",
          submenu: [
            {
              title: t("Dewan Penyantun"),
              key: "dewan-penyantun",
              link: "/tentang/manajemen/dewan-penyantun",
            },
            {
              title: t("Dewan Pengawas"),
              key: "dewan-pengawas",
              link: "/tentang/manajemen/dewan-pengawas",
            },
            {
              title: t("Direksi"),
              key: "direksi",
              link: "/tentang/manajemen/direksi",
            },
          ],
        },
        // {
        //   title: t("Testimoni"),
        //   key: "testimoni",
        //   link: "/tentang/testimoni/",
        // },
        {
          title: t("Penghargaan"),
          key: "penghargaan",
          link: "/tentang/penghargaan",
        },
      ],
    },
    {
      title: t("Investasi"),
      key: "investasi",
      link: "#",
      submenu: [
        {
          title: t("Dana Abadi"),
          key: "dana-abadi",
          link: "/investasi/dana-abadi/",
        },
        {
          title: t("Skema dan Kebijakan"),
          key: "skema-kebijakan",
          link: "/investasi/skema-kebijakan/",
        },
        {
          title: t("Instrumen dan Portofolio"),
          key: "instrumen-portfolio",
          link: "/investasi/instrumen-portfolio/",
        },
      ],
    },
    {
      title: t("Beasiswa"),
      key: "beasiswa",
      link: "#",
      submenu: [
        {
          title: t("Pendaftaran dan Penjadwalan"),
          key: "pendaftaran-penjadwalan",
          link: "/beasiswa/pendaftaran-beasiswa/",
        },
        {
          title: t("Kebijakan Umum"),
          key: "kebijakan-umum",
          link: "/beasiswa/kebijakan-umum/",
        },
        {
          title: t("Beasiswa Afirmasi"),
          key: "basiswa-afirmasi",
          submenu: submenus.affirmations.page_contents.map(d => {
            return {
              title: d.header_title,
              key: d.slug,
              link: "/beasiswa/afirmasi/" + d.slug,
            }
          }),
        },
        {
          title: t("Beasiswa Targeted"),
          key: "basiswa-targeted",
          link: "/beasiswa/kebijakan-umum/",
          submenu: submenus.scholarshipTargeted.page_contents.map(d => {
            return {
              title: d.header_title,
              key: d.slug,
              link: "/beasiswa/targeted/" + d.slug,
            }
          }),
        },
        {
          title: t("Beasiswa Umum"),
          key: "basiswa-umum",
          link: "/beasiswa/kebijakan-umum/",
          submenu: submenus.scholarshipGenerals.page_contents.map(d => {
            return {
              title: d.header_title,
              key: d.slug,
              link: "/beasiswa/umum/" + d.slug,
            }
          }),
        },
        {
          title: t("Beasiswa Kolaborasi"),
          key: "basiswa-kolaborasi",
          link: "/beasiswa/kebijakan-umum/",
          submenu: submenus.scholarshipCollaborations.page_contents.map(d => {
            return {
              title: d.header_title,
              key: d.slug,
              link: "/beasiswa/kolaborasi/" + d.slug,
            }
          }),
        },
      ],
    },
    {
      title: t("Awardee"),
      key: "awardee",
      link: "#",
      submenu: [
        // {
        //   title: t("Persiapan Keberangkatan"),
        //   key: "persiapan-keberangkatan",
        //   link: "#",
        //   submenu: [
        //     {
        //       title: t("Kebijakan"),
        //       key: "persiapan-keberangkatan-kebijakan",
        //       link: "/awardee/persiapan-keberangkatan/kebijakan/",
        //     },
        //     {
        //       title: t("Angkatan"),
        //       key: "persiapan-keberangkatan-angkatan",
        //       link: "/awardee/persiapan-keberangkatan/angkatan/",
        //     },
        //   ],
        // },
        // {
        //   title: t("Pengayaan Bahasa"),
        //   key: "pengayaan-bahasa",
        //   link: "#",
        //   submenu: [
        //     {
        //       title: t("Kebijakan"),
        //       key: "pengayaan-bahasa-kebijakan",
        //       link: "/awardee/pengayaan-bahasa/kebijakan/",
        //     },
        //   ],
        // },
        {
          title: t("Penerima Beasiswa"),
          key: "penerima-beasiswa",
          link: "#",
          submenu: [
            // {
            //   title: t("Panduan"),
            //   key: "penerima-beasiswa-panduan",
            //   link: "/awardee/penerima-beasiswa/panduan/",
            // },
            {
              title: "Simonev",
              key: "penerima-beasiswa-simonev",
              link: "https://www.simonev.lpdp.kemenkeu.go.id/Account/LogOn",
            },
            {
              title: "Sipendob",
              key: "penerima-beasiswa-sipendob",
              link: "https://www.simonev.lpdp.kemenkeu.go.id/sipendob/logon",
            },
            {
              title: t("Monev Perguruan Tinggi"),
              key: "penerima-beasiswa-monev",
              link: "https://www.simonev.lpdp.kemenkeu.go.id/Account/LogOn",
            },
          ],
        },
        // {
        //   title: t("Alumni"),
        //   key: "alumni",
        //   link: "#",
        //   submenu: [
        //     {
        //       title: t("Alumni"),
        //       key: "alumni-panduan",
        //       link: "/awardee/alumni/",
        //     },
        //     {
        //       title: t("Featured Alumni"),
        //       key: "featured-alumni",
        //       link: "/awardee/alumni/featured-alumni/",
        //     },
        //     {
        //       title: t("Mata Garuda"),
        //       key: "mata-garuda/",
        //       link: "https://matagaruda.org/",
        //     },
        //   ],
        // },
        // {
        //   title: t("Kontribusi"),
        //   key: "kontribusi",
        //   link: "/awardee/kontribusi/",
        // },
      ],
    },
    {
      title: t("Riset"),
      key: "Riset",
      link: "#",
      submenu: [
        {
          title: t("Pendaftaran Penjadwalan"),
          key: "pendaftaran-penjadwalan",
          link: "/riset/pendaftaran-penjadwalan/",
        },
        {
          title: t("Kebijakan RISPROS Umum"),
          key: "kebijakan-rispros-umum",
          link: "/riset/kebijakan-rispros-umum/",
        },
        {
          title: t("RISPRO Kompetisi"),
          key: "rispro-kompetisi",
          link: "#",
          submenu: submenus.researchRisproCompetitions.page_contents.map(d => {
            return {
              title: d.header_title,
              key: d.slug,
              link: "/riset/kompetisi/" + d.slug,
            }
          }),
        },
        {
          title: t("RISPRO Invitasi"),
          key: "rispro-invitasi",
          link: "#",
          submenu: submenus.researchRisproInvitations.page_contents.map(d => {
            return {
              title: d.header_title,
              key: d.slug,
              link: "/riset/invitasi/" + d.slug,
            }
          }),
        },
        {
          title: t("RISPRO Mandatori"),
          key: "rispro-mandatori",
          link: "#",
          submenu: submenus.researchRisproMandatories.page_contents.map(d => {
            return {
              title: d.header_title,
              key: d.slug,
              link: "/riset/mandatori/" + d.slug,
            }
          }),
        },
        {
          title: t("RISPRO Kolaborasi"),
          key: "rispro-collaboration",
          link: "#",
          submenu: submenus.researchRisproCollaborations.page_contents.map(
            d => {
              return {
                title: d.header_title,
                key: d.slug,
                link: "/riset/kolaborasi/" + d.slug,
              }
            }
          ),
        },
      ],
    },
    // {
    //   title: t("Grantees"),
    //   key: "grantees",
    //   link: "#",
    //   submenu: [
    //     {
    //       title: t("Daftar Grantees"),
    //       key: "daftar-grantees",
    //       link: "/grantees/daftar-grantees/",
    //     },
    //     {
    //       title: t("Kisah Inpiratif RISPRO"),
    //       key: "kisah-inspiratif-rispro",
    //       link: "/grantees/kisah-inspiratif-rispro/",
    //     },
    //     {
    //       title: t("RISPRO Tech Brief"),
    //       key: "rispro-tech-brief",
    //       link: "/grantees/rispro-tech-brief/",
    //     },
    //   ],
    // },
    {
      title: t("Informasi"),
      key: "informasi",
      link: "#",
      submenu: [
        {
          title: t("Laporan"),
          key: "laporan",
          link: "#",
          submenu: [
            {
              title: t("Laporan Keuangan"),
              key: "laporan-keuangan",
              link: "/informasi/laporan-keuangan/",
            },
            {
              title: t("Laporan Tahunan"),
              key: "laporan-tahunan",
              link: "/informasi/laporan-tahunan/",
            },
            {
              title: t("Laporan Kinerja"),
              key: "laporan-kinerja",
              link: "/informasi/laporan-kinerja/",
            },
            {
              title: t("Infografik"),
              key: "infografik",
              link: "/informasi/infografik/",
            },
          ],
        },
        // {
        //   title: t("Berita"),
        //   key: "berita",
        //   link: "/informasi/berita",
        // },
        // {
        //   title: t("Karir"),
        //   key: "karir",
        //   link: "/informasi/karir",
        // },
        {
          title: t("Live"),
          key: "live",
          link: "/informasi/live",
        },
        {
          title: "FAQ",
          key: "faq",
          link: "#",
          submenu: [
            {
              title: t("Daftar Pertanyaan"),
              key: "daftar-pertanyaan",
              link: "https://bantuan.lpdp.kemenkeu.go.id/kb",
            },
            {
              title: t("Investasi"),
              key: "faq-investasi",
              link: "/investasi/dana-abadi/",
            },
            {
              title: t("Beasiswa"),
              key: "faq-beasiswa",
              link: "/beasiswa/kebijakan-umum/",
            },
            {
              title: t("Riset"),
              key: "faq-riset",
              link: "/riset/kebijakan-rispros-umum/",
            },
          ],
        },
        {
          title: t("Hubungi Kami"),
          key: "hubungi-kami",
          link: "/informasi/hubungi-kami/",
        },
      ],
    },
  ]
  return menus
}
